// extracted by mini-css-extract-plugin
export default {"serviceCard":"ServiceCard_serviceCard__cqgQf"};